import styled from '@emotion/styled';
import { useSanitizedHtml } from 'hooks/useSanitizedHtml';
import { HorizontalRuleStyle } from './styles';

const TextViewWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'fontSize' && prop !== 'fontFamily',
})`
  font-size: ${({ fontSize = '14px' }) => fontSize};
  font-family: ${({ fontFamily = 'Arial' }) => fontFamily};

  /* Reccomended layout CSS from TipTap */
  > * + * {
    margin-top: 0;
  }

  ${HorizontalRuleStyle}

  /* Else sequential newlines are collapsed */
  p:empty:before {
    content: ' ';
    white-space: pre;
  }

  * {
    font-family: inherit;
    font-size: inherit;
    line-height: 1.5em;
  }
`;

/**
 * Pass the HTML content received from an editing context to display it properly in this view
 */
export const TextViewer = ({
  content,
  className,
  style,
  fontFamily = 'Arial',
  fontSize = '14px',
}) => {
  const sanitized = useSanitizedHtml(content);

  return (
    <TextViewWrapper
      className={className}
      style={style}
      fontFamily={fontFamily}
      fontSize={fontSize}
      dangerouslySetInnerHTML={{ __html: sanitized }}
    />
  );
};
